import { Element } from 'react-scroll/modules';
import { usePHSPACCResultsVideo } from '@components/phs/pacc/results/query/useResults';
import V4Result from './v4Result';
import V4Check from './v4Check';
import V4Notice from './v4Notice';
import TestGuideHeader from '../testGuideHeader';
import { PaccApplyResultVO } from '@domain/vo/phs/pacc/results/PaccApplyResultVO';
import { AccTaskModuleEnum } from '@domain/constant/acca/TaskType';
import classNames from 'classnames/bind';
import styles from './v4Guide.module.scss';

const cx = classNames.bind(styles);

interface V4GuideProps {
  sn: number;
  applyResult: PaccApplyResultVO;
}

const V4Guide = ({ sn, applyResult }: V4GuideProps) => {
  const { data: videoResult } = usePHSPACCResultsVideo(sn);

  if (!videoResult) return null;

  return (
    <Element name={AccTaskModuleEnum.VIDEO} className={cx('testGuideWrap')}>
      <TestGuideHeader moduleType={AccTaskModuleEnum.VIDEO} applyResult={applyResult} />

      <div className={cx('contentWrap')}>
        <div className={cx('contentBox')}>
          {/* [D] 영상 종합 분석 결과 영역 */}
          <V4Result videoResult={videoResult} />
        </div>

        <div className={cx('contentBox')}>
          {/* [D] 내 영상 확인하기 영역 */}
          <V4Check videoResult={videoResult} />

          {/* [D] 도움말 영역 */}
          <V4Notice />
        </div>
      </div>
    </Element>
  );
};

export default V4Guide;
